import { SelectInput } from 'react-admin';
import { useState, useEffect } from 'react';
import { SelectInputProps } from 'ra-ui-materialui';

import { AdminOptionCats } from '@types';
import { adminSettingsHttp } from '@network';


interface Props extends SelectInputProps {
  category: AdminOptionCats;
}

interface Option {
  id: number;
  name: string;
}

export const AdminOptionsSelect = (props: Props) => {
  const [choices, setChoices] = useState<Option[]>([]);

  useEffect(() => {
    (async () => {
      const ops = await adminSettingsHttp.getOptionsByCategory(props.category);
      setChoices((ops || [])
        .map(o => ({ id: o.id as number, name: o.name })));
    })();
  }, []);

  return (
    <SelectInput
      {...props}
      source={props.source}
      choices={choices}
      optionText="name"
      optionValue="id"
    />
  );
};
